<template>
  <div>
    <v-layout row>
      <v-flex
        xs12
        sm12
        md12
        lg10
        offset-lg1
        xl10
        offset-xl1
      >
        <v-card flat>
          <v-card-text>
            <div class="select-outlet">
              Our Outlets
            </div>
            <v-layout 
              row
              wrap
            >
              <v-flex
                d-flex
                xs12
                sm6
                md4
                lg3
                xl2
                v-for="(outlet, index) in restaurants"
                :key="index"
                class="my-3"
              >
                <outlet-selector :outlet="outlet" />
              </v-flex>
            </v-layout>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
import axios from 'axios'
import { mapGetters } from 'vuex'
import OutletSelector from '~/components/OutletSelector'

export default {
  name: 'advertised-outlets',
  layout: 'common',
  metaInfo () {
    return { title: 'All Outlets' }
  },
  data () {
    return {
      restaurants: [],
    }
  },
  components: {
    'outlet-selector': OutletSelector
  },
  async created () {
    const { data } = await axios.get('/api/advertised_outlets')
    this.restaurants = data
  }
}
</script>

<style scoped>
.select-outlet {
  font-size: 20px;
  text-transform: uppercase;
}
</style>


// WEBPACK FOOTER //
// src/pages/advertised_outlets.vue